"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ReversedSortOrders = void 0;
var ReversedSortOrders;
(function (ReversedSortOrders) {
    ReversedSortOrders["ReverseCustom"] = "-custom";
    ReversedSortOrders["ReverseRelevance"] = "-relevance";
    ReversedSortOrders["ReverseDate"] = "-date";
    ReversedSortOrders["ReverseName"] = "-name";
})(ReversedSortOrders = exports.ReversedSortOrders || (exports.ReversedSortOrders = {}));
//# sourceMappingURL=video.types.js.map